const PROMISE_STATUS = Object.freeze({
  fulfilled: 'fulfilled',
  rejected: 'rejected',
});

// noinspection JSUnusedGlobalSymbols
export default PROMISE_STATUS;
